import {
  LayoutDashboard,
  Receipt,
  FileText,
  Boxes,
  PackagePlus,
  ShoppingCart,
  Undo2,
  Database,
  BarChart3,
  Settings,
} from 'lucide-react';
import Container from '../../common/Container';

interface PharmacyModuleNavProps {
  activeModule: string;
  onSelectModule: (id: string) => void;
}

export const pharmacyModuleList = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'create-invoice', label: 'POS Billing', icon: Receipt },
  { id: 'sales-invoice', label: 'Sales Invoices', icon: FileText },
  { id: 'stock-inventory', label: 'Stock Inventory', icon: Boxes },
  { id: 'add-stock', label: 'Inward GRN', icon: PackagePlus },
  { id: 'purchase-order', label: 'Purchase Orders', icon: ShoppingCart },
  { id: 'return-medicine', label: 'Returns & Credit', icon: Undo2 },
  { id: 'master-catalog', label: 'Master Catalog', icon: Database },
  { id: 'reports', label: 'Reports & GST', icon: BarChart3 },
  { id: 'settings', label: 'Settings', icon: Settings },
];

export const PharmacyModuleNav: React.FC<PharmacyModuleNavProps> = ({
  activeModule,
  onSelectModule,
}) => {
  return (
    <div className="sticky top-[69px] z-40 bg-white/90 backdrop-blur-md border-b border-slate-200/80 py-3 shadow-sm">
      <Container>
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar scroll-smooth py-1">
          <span className="text-xs font-bold uppercase tracking-wider text-slate-400 whitespace-nowrap mr-2 hidden sm:inline-block">
            Pharmacy Jump:
          </span>
          {pharmacyModuleList.map((mod) => {
            const Icon = mod.icon;
            const isActive = activeModule === mod.id;
            return (
              <button
                key={mod.id}
                onClick={() => onSelectModule(mod.id)}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs md:text-sm font-semibold whitespace-nowrap transition-all duration-200 ${
                  isActive
                    ? 'bg-[#0D7893] text-white shadow-md shadow-[#0D7893]/25 scale-105'
                    : 'bg-slate-100 text-slate-700 hover:bg-[#0D7893]/10 hover:text-[#0D7893]'
                }`}
              >
                <Icon className={`w-4 h-4 ${isActive ? 'text-white' : 'text-[#0D7893]'}`} />
                <span>{mod.label}</span>
              </button>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default PharmacyModuleNav;
